import { CclInfoTableRowTemplate } from "../../../../components/common/cclInfoTable/cclInfoTable";

export const CclInfoTblInventoryTemplate: CclInfoTableRowTemplate[] = [
    /**
    aagKey: number;
    aagName: string;
    partNumber: number;
    instrumentName: string;
    availableQty: number;
    reservedQty: number;
    projectedAvailable: number;
     */
    {
        id: "instrumentName",
        fieldType: "string",
        editable: false,
        label: "Assessment",
        required: false,
        value: "",
        actionField: null,
        valueField: {
            value: "",
            editFieldType: 0,
            url: null,
            hoverText: null,
            checked: null,
            id: "",
            selectOptions: null, //TODO: Fix this for drop down option
        },
    },
    {
        id: "availableQty",
        fieldType: "string",
        editable: false,
        label: "Unused",
        required: false,
        value: "",
        actionField: null,
        infoText: "Inventory not yet accessed by invited participants.",
        valueField: {
            value: "",
            editFieldType: 0,
            url: null,
            hoverText: null,
            checked: null,
            id: "",
            selectOptions: null, //TODO: Fix this for drop down option
        },
    },
    {
        id: "reservedQty",
        fieldType: "string",
        editable: false,
        label: "Pending",
        required: false,
        value: "",
        actionField: null,
        infoText: "Inventory reserved for participants awaiting invitations.",
        valueField: {
            value: "",
            editFieldType: 0,
            url: null,
            hoverText: null,
            checked: null,
            id: "",
            selectOptions: null, //TODO: Fix this for drop down option
        },
    },
    {
        id: "projectedAvailable",
        fieldType: "string",
        editable: false,
        label: "Available",
        required: false,
        value: "",
        actionField: null,
        infoText: "Inventory available for new registrations.",
        valueField: {
            value: "",
            editFieldType: 0,
            url: null,
            hoverText: null,
            checked: null,
            id: "",
            selectOptions: null, //TODO: Fix this for drop down option
        },
    },
];
